module.exports = "https://www.gc-qa.gnp.com.mx/3e316cc0d9cb77042673df280379b85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_instagram.png
// module id = 8134
// module chunks = 0